// import { Link } from "react-router-dom"
import "./Makura.css"

export default function Makura() {
  return (
    <div className="makura">
      <nav>
        <a href="/#home" className="floating-nav-button">
          <h4>↩︎</h4>
        </a>
      </nav>
    </div>
  )
}
